import { useCallback } from 'react';
import { parseLooseAppManifest } from '@wix/cli-app-manifest';
import type { DevMetadata } from '@wix/cli-astro-definitions';
import { useHttpClient } from '@wix/cli-http-client-react';
import { isTunnelRequired } from '../utils/isTunnelRequired.js';

export function useFetchAppManifest() {
  const http = useHttpClient({ type: 'standalone' });

  return useCallback(
    async (
      serverLocalUrl: string,
      devMetadata: DevMetadata | null,
      baseUrl: string,
      tunnelUrl: string
    ) => {
      const url = new URL('/_wix/app-manifest.json', serverLocalUrl);
      const { data: text } = await http.get<string>(url.toString(), {
        responseType: 'text',
        transitional: {
          silentJSONParsing: true,
          forcedJSONParsing: false,
          clarifyTimeoutError: false,
        },
        disableWixHeaders: true,
      });

      if (devMetadata != null) {
        const { staticsUrlPlaceholder, serverUrlPlaceholder } = devMetadata;
        const placeholders = new Map<string, string>();

        placeholders.set(staticsUrlPlaceholder, baseUrl);
        placeholders.set(serverUrlPlaceholder, tunnelUrl);

        return {
          manifest: parseLooseAppManifest(text, placeholders),
          isTunnelRequired: text.includes(serverUrlPlaceholder),
        };
      }

      const manifestV1 = parseLooseAppManifest(text);

      return {
        manifest: manifestV1,
        isTunnelRequired: isTunnelRequired(manifestV1),
      };
    },
    [http]
  );
}
